import { message } from "antd";
import { NotificationManager } from "react-notifications";

// Deduplicate antd message notifications (error, warning, info, success)
["error", "warning", "info", "success"].forEach((type) => {
  const original = message[type];
  if (typeof original === "function") {
    let lastKey = null;
    let lastTime = 0;

    message[type] = function (content, duration, onClose) {
      const text =
        typeof content === "object" && content !== null
          ? content.content || JSON.stringify(content)
          : String(content);
      const now = Date.now();
      if (text === lastKey && now - lastTime < 1500) {
        const noopResult = function () {};
        noopResult.then = (fn) => Promise.resolve(true).then(fn);
        noopResult.promise = Promise.resolve(true);
        return noopResult;
      }
      lastKey = text;
      lastTime = now;
      return original.apply(this, arguments);
    };
  }
});

// Deduplicate react-notifications NotificationManager
if (NotificationManager && typeof NotificationManager.create === "function") {
  const originalCreate = NotificationManager.create.bind(NotificationManager);
  let lastNotifyKey = null;
  let lastNotifyTime = 0;

  NotificationManager.create = function (notify) {
    const key = `${notify.type}_${notify.title}_${notify.message}`;
    const now = Date.now();
    if (key === lastNotifyKey && now - lastNotifyTime < 1500) {
      return;
    }
    lastNotifyKey = key;
    lastNotifyTime = now;
    return originalCreate(notify);
  };
}
